import type { SnackbarElement, SnackbarType } from '@comp/customHtml/Snackbar'

export const notify = (message: string, type?: SnackbarType) => {
  const snackbar = document.querySelector<SnackbarElement>('app-snackbar')
  if (!snackbar) {
    alert(message)
    return
  }

  snackbar.show(message, type || 'Info')
}
